<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filters-general ref="filtersReport"></filters-general>
            </div>
            <div class="col-md-9" >
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReport">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResult">
                        <div v-if="loadfile">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfile"  class="btn btn-success" type="button" @click="ExportFile"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Descargar Excel</b></button>
                    </div>
                </div><br>
                <div class="row" v-show="showResult">
                    <div class="col-md-12" v-show="showResult">
                        <v-client-table :data="tableDataResumenInfomracion" :columns="columnsResumenInformacion" :options="optionsResumenInformacion" class="table-responsive" ref="tableFaltantes">
                            <div slot="Gestor" slot-scope="props">
                                <span v-html="props.row.Gestor"></span>
                            </div>
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaResumen",
    data(){
        return{
            loadfile:false,
            showResult:false,
            loadingGetData: false,
            showData: false,
            columnsResumenInformacion: ['Id','Gestor','Ciudad','Agencia','Encuestas','Faltantes','Promociones','Anaquel','Exhibiciones','Precios','PreciosM','Fotografico','Comentarios','Ventas','Resurtido','Inventario','Visitas','Pendientes','Canceladas','Evaluacion'],
            tableDataResumenInfomracion: [],
            optionsResumenInformacion: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Gestor','Ciudad','Agencia'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                    Evaluacion: [
                        {
                            class:'bg-danger',
                            condition: row => row.Evaluacion <= 60
                        },
                        {
                            class:'bg-warning',
                            condition: row => row.Evaluacion <= 80
                        },
                        {
                            class:'bg-success',
                            condition: row => row.Evaluacion > 80
                        }
                    ]
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                    Encuestas: 'Total De Registros Encuestas',
                    Faltantes: 'Total De Registros Faltantes',
                    Promociones: 'Total De Registros Proociones',
                    Anaquel: 'Total De Registros Anaquel',
                    Exhibiciones: 'Total De Registros Exhibiciones',
                    Precios: 'Total De Registros Precios',
                    PreciosM: 'Total De Registros Precios Mayoreo',
                    Fotografico: 'Total De Registros Fotográfico',
                    Comentarios: 'Total De Registros Comentarios',
                    Ventas: 'Total De Registros Ventas',
                    Resurtido: 'Total De Registros Resurtidos',
                    Inventario: 'Total De Registros Inventarios',
                    Evaluacion: 'Evaluación',

                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Agencia: 'text-justify',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Encuestas: 'text-center',
                    Faltantes: 'text-center',
                    Promociones: 'text-center',
                    Anaquel: 'text-center',
                    Exhibiciones: 'text-center',
                    Precios: 'text-center',
                    PreciosM: 'text-center',
                    Fotografico: 'text-center',
                    Comentarios: 'text-center',
                    Ventas: 'text-center',
                    Resurtido: 'text-center',
                    Inventario: 'text-center',
                    Visitas: 'text-center',
                    Pendientes: 'text-center',
                    Canceladas: 'text-center',
                    Evaluacion: 'text-center tx-bold',

                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReport();
            }
        },
        getReport(){ let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetData = true;
                this.showData = false;
                this.showResult = false;
                this.tableDataInventario = [];
                axios.post('/api/DetalleInformacion/TablaResumen',{data:filters})
                    .then(r => {
                            $this.loadingGetData = false;
                            $this.showData = true;
                            $this.tableDataResumenInfomracion = r.data.Data;
                            $this.showResult = true;
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        }
                    );
            }
        },
        ExportFile(){let $this = this;
            this.loadfile = true;
            var filters = this.$refs.filtersReport.filters;
            axios({
                method: 'post',
                url: '/api/DetalleInformacion/exportLayoutToExcelResumen',
                responseType: 'arraybuffer',
                data: {data: filters}}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'ResumenCapturaMoet.xlsx'
                    link.click()
                    $this.loadfile=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfile=false;
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
